var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconColumnPlus = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", stroke: props.color, strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { strokeWidth: 1, d: "M5.3,24.8v-7.6h7.6v7.6H5.3z" }),
            React.createElement("path", { strokeWidth: 1, d: "M5.3,12.8V5.3h7.6v7.6L5.3,12.8L5.3,12.8z" }),
            React.createElement("path", { strokeWidth: 1, d: "M17.2,12.9V5.3h7.6v7.6H17.2z" }),
            React.createElement("path", { d: "M16.5,21c3,0,6,0,9,0" }),
            React.createElement("path", { d: "M21,16.5c0,3,0,6,0,9" }))));
});
export default IconColumnPlus;
//# sourceMappingURL=IconColumnPlus.js.map